import {FC, useEffect, useState} from "react";
import {IGroup} from "../Interfaces/IGroup";
import AxiosServices from "../Services/axiosServices";
import {useGlobal} from "../config/GlobalContext";

const Groups: FC = () => {
    const [groups, setGroups] = useState<IGroup[]>([]);
    const {currentCmpEdt} = useGlobal();

    useEffect(() => {
        AxiosServices.getGroups(setGroups, currentCmpEdt)
            .then()
            .catch(err => {
                console.log(err);
            });
    }, [currentCmpEdt]);

    return (
        <div className={"overview"}>
            <ul>
                {groups.map((group: IGroup) => (
                    <ul>Groupe {group.Grp_Cod}</ul>
                ))}
            </ul>
        </div>
    )
}
export default Groups;